import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.step9.sectionTitle',
    defaultMessage: 'Section 6 - Rental Vehicle Excess',
  },
  yes: {
    id: 'fastCover.step9.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.step9.no',
    defaultMessage: 'No',
  },
  areYouClaimingForRentalVehicleExcess: {
    id: 'fastCover.step9.areYouClaimingForRentalVehicleExcess',
    defaultMessage: 'Are you claiming for Rental Vehicle Excess?',
  },
  toAssistYourClaim: {
    id: 'fastCover.step9.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.step9.toAssistYourClaim',
    defaultMessage:
      'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.step9.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.step9.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.step9.document1',
    defaultMessage:
      'A full copy of your rental vehicle agreement. It must show the excess you were liable to pay under the agreement.',
  },
  document2: {
    id: 'fastCover.step9.document2',
    defaultMessage:
      'A copy of the itemised invoice for the repairs to the rental vehicle.',
  },
  document3: {
    id: 'fastCover.step9.document3',
    defaultMessage:
      'Copy of your Australian Drivers licence or Motorcycle licence and any international or foreign countries drivers or motorcycle licence.',
  },
  document4: {
    id: 'fastCover.step9.document4',
    defaultMessage:
      'Copy of the police report or report to relevant authority.',
  },
  document5: {
    id: 'fastCover.step9.document5',
    defaultMessage:
      'Copy of your credit card statement showing the amount paid for the rental vehicle excess.',
  },
  provideExplanation: {
    id: 'fastCover.step9.provideExplanation',
    defaultMessage:
      'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  previousDescriptionOfWhatHappened: {
    id: 'fastCover.step9.previousDescriptionOfWhatHappened',
    defaultMessage:
      'Include any additional information you may have to add to your previous description of what happened.',
  },
  nameOfThePersonDrivingTheCar: {
    id: 'fastCover.step9.nameOfThePersonDrivingTheCar',
    defaultMessage: 'Name of the person driving the car',
  },
  driverDateOfBirth: {
    id: 'fastCover.step9.driverDateOfBirth',
    defaultMessage: "Driver's Date of Birth",
  },
  dateOfExpense: {
    id: 'fastCover.step9.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  description: {
    id: 'fastCover.step9.description',
    defaultMessage: 'Description',
  },
  descriptionEg: {
    id: 'fastCover.step9.descriptionEg',
    defaultMessage: 'e.g.Flight to Paris',
  },
  rentalVehicleExcessAmount: {
    id: 'fastCover.step9.rentalVehicleExcessAmount',
    defaultMessage: 'Rental Vehicle Excess charged',
  },
  currency: {
    id: 'fastCover.step9.currency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.step9.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  actualRepairAmount: {
    id: 'fastCover.step9.actualRepairAmount',
    defaultMessage: 'Actual Repair amount',
  },
  amountClaimed: {
    id: 'fastCover.step9.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  isRequired: {
    id: 'fastCover.step9.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  other1: {
    id: 'fastCover.step9.other1',
    defaultMessage: 'Your rental vehicle agreement that states the rental vehicle excess',
  },
  other2: {
    id: 'fastCover.step9.other2',
    defaultMessage: 'A quote or repair invoice for the rental vehicle damage',
  },
  other3: {
    id: 'fastCover.step9.other3',
    defaultMessage: 'Copy of your Australian Drivers license or motorcycle license and any other international drivers or motorcycle license.',
  },
  other4: {
    id: 'fastCover.step9.other4',
    defaultMessage: 'A police or accident report from the relevant authority',
  },
  other5: {
    id: 'fastCover.step9.other5',
    defaultMessage: 'Copy of your bank or credit card statement showing the amount paid for the rental vehicle excess',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step9/messages.js